<template>
  <div class="item-wrap" :class="{ active: hasBeenLiked }">
    <div class="who">
      <p>{{ itemObj.name }}</p>
      <p class="town">{{ itemObj.location }}</p>
    </div>
    <div class="image" @click="likeMe">
      <img :src="itemObj.photo_url">
    </div>
    <div class="vote">
      <div class="likes">
        <img src="" alt="">
        <p @click="likeMe">
          <span v-if="hasBeenLiked"><img src="@/assets/liked.svg"></span>
          <span v-else><img src="@/assets/unliked.svg"></span>
          {{ itemObj.likes }} Likes
        </p>
      </div>
      <div class="share">
        <a href="https://www.facebook.com/sharer/sharer.php?u=http://jeepgallery.ongoing.co.nz" target="_blank">
          <img src="@/assets/share.jpg">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemObj'],
  data () {
    return {
      hasBeenLiked: false
    }
  },
  mounted () {
    this.likeCheck()
  },
  updated () {
    this.likeCheck()
  },
  methods: {
    likeMe () {
      this.$store.commit('openModal', this.itemObj)
      this.likeCheck()
    },
    likeCheck () {
      if (this.$store.state.logged_in) {
        let likeCheck = this.$store.state.config.user.what_i_like.find(item => item.id === this.itemObj.id)
        if (likeCheck) {
          this.hasBeenLiked = true
          console.log(likeCheck)
        } else {
          this.hasBeenLiked = false
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "../scss/variables.scss";

/*
  https://github.com/bfred-it/object-fit-images/
  @include object-fit(cover, top);
*/
@mixin object-fit($fit: fill, $position: null){
    -o-object-fit: $fit;
        object-fit: $fit;
    @if $position {
        -o-object-position: $position;
            object-position: $position;
        font-family: 'object-fit: #{$fit}; object-position: #{$position}';
    } @else {
        font-family: 'object-fit: #{$fit}';
    }
}

.item-wrap {
  width: 100%;

  .who {
    p {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      line-height: 16px;
      color: $color-1a;
    }
    p.town {
      margin-bottom: 5px;
      font-size: 12px;
      font-weight: 400;
      line-height: 23px;
      color: #ffffff;
    }
  }

  .image {
    width: 100%;
    padding: 4px 4px 14px;
    background: white;

    img {
      width: 100%;
      min-height: 180px;
      @include object-fit(cover, center);
    }
  }

  .vote {
    display: inline-block;
    width: 100%;
    padding: 5px 14px 11px;
    background: white;
    text-align: center;
    @media (min-width: $mediumish) {
      padding: 0 14px 11px;
    }

    .likes {
      margin: auto;
      padding: 3px 0;
      @media (min-width: $medium) {
        float: left;
      }

      img {
        display: inline-block;
      }
      p {
        display: inline-block;
        margin: 0;

        color: #424242;
        font-size: 13px;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: -0.2px;
      }
    }

    .share {
      margin: auto;
      @media (min-width: $medium) {
        float: right;
      }

      img {
        width: 61px;
        margin: 10px auto 0;
        @media (min-width: $medium) {
          margin: auto;
        }
      }
    }
  }
}
</style>
